import { useAppSelector } from '../redux/hooks';

/**
 * Hook to determine whether the currently signed-in user is a GIG worker.
 * Centralizes the `team === 'G'` check so it can be reused across the app
 * (sidebar navigation, my-shifts routing, etc.).
 */
export const useIsGigWorker = (): boolean => {
    const { user } = useAppSelector((state) => state.currentUser);
    return user?.team === 'G';
};
